import React from "react"
import "../css/resource.css"
import { Link, useStaticQuery } from "gatsby"

class Resource extends React.Component {
  constructor(props) {
    super(props)
  }

  handlecContent() {
    return (
      <div className="resource">
        {this.props.image}
        <div>
          <h4 style={this.props.color&&({color:this.props.color})}>{this.props.title}</h4>
          <p>{this.props.text}</p>
        </div>
      </div>
    )
  }

  handleResources() {}

  render() {
    return (
      <>
        {this.props.url.charAt(0) == "/" ? (
          <Link to={this.props.url}  target="_blank">{this.handlecContent()}</Link>
        ) : (
          <a href={this.props.url} target="_blank">{this.handlecContent()}</a>
        )}
      </>
    )
  }
}

export default Resource
